import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getDepartment } from "../../../../../action/masters/departmentActionCreator";
import { cloneDeep, baseURL } from "../../../../../constants/commonConstants";
import {
  IDepartmentDetails,
  IDepartmentData,
} from "../../../../../models/master/department";
import DepartmentEdit from "./departmentEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import { setDepartment } from "../../../../../store/slices/master/departmentSlice";

const DepartmentDetails = (props: IDepartmentDetails) => {
  const { getDepartment, department } = props;
  const [data, setData] = useState<IDepartmentData>(cloneDeep(department));
  const [showEdit, setShowEdit] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const getDepartmentData = async () => {
    setIsLoading(true);
    try {
      await getDepartment();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDepartmentData();
  }, []);

  useEffect(() => {
    if (department) {
      setData(cloneDeep(department));
    }
  }, [department]);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getDepartment(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setDepartment([]));
    };
  }, []);

  return (
    <>
      <div className="admin-wrap">
        <div className="admincontent">
          <div className="title">
            <h2>Department Details</h2>
            {data && (
              <a
                href="javascript:void(0)"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#editdepartement"
                onClick={() => editItem(data.id ?? 0)}
              >
                <img
                  src="/assets/images/icon/edit-wh.svg"
                  alt=""
                  className="me-2"
                />
                Edit Details
              </a>
            )}
          </div>
          {isLoading ? (
            <LoaderSpinner />
          ) : (
            data && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <p>
                      <img
                        src={
                          data?.departmentLogo
                            ? baseURL + data.departmentLogo
                            : ""
                        }
                        style={{ width: "150px", height: "150px" }}
                        className="mb-3"
                        alt=""
                      />
                    </p>

                    <div className="row">
                      <div className="col-lg-6 label-group">
                        <label>Department Name</label>
                        <p>{data.name}</p>
                      </div>
                      <div className="col-lg-6 label-group">
                        <label>Address</label>
                        <p>{data.address}</p>
                      </div>
                      <div className="col-lg-6 label-group">
                        <label>Location</label>
                        <p>{data.location}</p>
                      </div>
                      <div className="col-lg-12 label-group">
                        <label>Description</label>
                        <p>{data.description}</p>
                      </div>
                      <div className="col-lg-6 label-group">
                        <label>Login User Name</label>
                        <p>{data.departmentLoginUserName}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <DepartmentEdit
            setShowEdit={handleEditClose}
            department={department}
            isCollegeAdmin={true}
            getDepartment={getDepartment}
          />
        </ReactModal>
      )}
    </>
  );
};

const mapDispatchToProps = {
  getDepartment: (id?: number) => getDepartment(id),
};

function mapStateToProps(state: any) {
  return {
    department: state.department.department,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentDetails);
